import UserDetailPage from './UserDetailPage'
export default UserDetailPage